/**
 * Aplica máscara de telefone brasileiro durante digitação
 * (XX) XXXX-XXXX ou (XX) XXXXX-XXXX
 */
export const aplicarMascaraTelefone = (valor: string): string => {
  const numeros = valor.replace(/\D/g, '').slice(0, 11);
  if (numeros.length <= 10) {
    return numeros.replace(/(\d{2})(\d{4})(\d{0,4})/, '($1) $2-$3');
  }
  return numeros.replace(/(\d{2})(\d{5})(\d{0,4})/, '($1) $2-$3');
};

/**
 * Formata telefone para exibição.
 * Se o valor contém apenas números (10 ou 11 dígitos), aplica máscara.
 * Caso contrário, retorna o valor original.
 */
export const formatarTelefone = (telefone: string): string => {
  const numeros = telefone.replace(/\D/g, '');
  if (numeros.length === 11) {
    return numeros.replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
  }
  if (numeros.length === 10) {
    return numeros.replace(/(\d{2})(\d{4})(\d{4})/, '($1) $2-$3');
  }
  return telefone;
};
